const testimonials = [
  {
    quote:
      "We used Bryan to book our family Disney World trip in Feb. 2024. He was able to get us 2 family suites right beside each other at the Art of Animation Resort. He also took care of our park tickets and getting our bands hooked up to our accounts! He did such a great job that we have already contacted him again for our Disney trip this fall.",
    author: "Taylor D.",
    detail: "Walt Disney World · February 2024",
  },
  {
    quote:
      "The whole experience was smooth all around. I contacted him with where and what I was looking for. He lined up a great and affordable option that same day. He was very attentive of my and my partner's needs, and was super easy to work with. The whole trip went off without a hitch.",
    author: "Coby",
    detail: "Lake George, New York",
  },
  {
    quote:
      "Bryan made booking, payments, and upgrades super easy. I've booked several cruises on my own and have struggled. He made sure to answer all my questions and gave me all the info I needed to make an educated decision on my options.",
    author: "Verified Review via Travel Leaders",
    detail: "Cruise to Cozumel, Mexico",
  },
  {
    quote:
      "Bryan was awesome when we came to him wanting to get our trip together. He got prices that I couldn't get anywhere else and was outstanding at getting back to me if I needed help. I've gotten a few more quotes from him and will continue using his services. 10/10 would highly recommend.",
    author: "Verified Review via Travel Leaders",
    detail: "Denver, Colorado",
  },
];

export const DestinationsSection = () => {
  return (
    <section className="py-28 bg-secondary" id="testimonials" aria-label="Client testimonials">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">

          {/* Header */}
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-4 mb-5">
              <div className="h-px flex-1 max-w-[60px] bg-gradient-to-r from-transparent to-gold/40" />
              <p className="font-cinzel text-[0.6rem] text-gold tracking-[0.35em] uppercase">Client Stories</p>
              <div className="h-px flex-1 max-w-[60px] bg-gradient-to-l from-transparent to-gold/40" />
            </div>
            <h2 className="font-serif font-light text-foreground mb-5"
                style={{ fontSize: "clamp(1.9rem, 4vw, 2.8rem)" }}>
              What Families Are Saying
            </h2>
            <p className="text-muted-foreground max-w-xl mx-auto font-sans">
              Not testimonials about "amazing experiences" — testimonials about what actually happened.
            </p>
          </div>

          {/* Testimonial grid */}
          <div className="grid md:grid-cols-2 gap-5">
            {testimonials.map((t, index) => (
              <div
                key={index}
                className="bg-card rounded-[3px] p-8 border border-border shadow-soft flex flex-col justify-between animate-slide-up relative overflow-hidden"
                style={{ animationDelay: `${index * 0.08}s` }}
              >
                {/* Ambient glow */}
                <div className="absolute top-0 left-0 w-32 h-32 bg-gold/4 rounded-full -translate-x-1/2 -translate-y-1/2 blur-2xl pointer-events-none" />

                <div className="mb-5 relative z-10">
                  <div
                    className="font-serif leading-none select-none mb-3"
                    aria-hidden="true"
                    style={{
                      fontSize: "3.5rem",
                      lineHeight: 1,
                      color: "hsl(46,67%,52%)",
                      opacity: 0.4,
                    }}
                  >
                    &ldquo;
                  </div>
                  <p className="text-foreground/75 text-[0.925rem] leading-relaxed font-sans -mt-2">
                    {t.quote}
                  </p>
                </div>

                <div className="pt-5 border-t border-border/60 relative z-10">
                  <p className="font-cinzel text-[0.6rem] tracking-[0.15em] uppercase text-foreground/80">
                    {t.author}
                  </p>
                  <p className="font-sans text-[0.75rem] text-muted-foreground mt-1">{t.detail}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
